import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.wrapper = this.$('wrapper')[0]
    this.thumbnailButton = this.$('thumbnail-button')[0]
    this.listButton = this.$('list-button')[0]

    this.events = {
      click: {
        'thumbnail-button': 'enterThumbnailView',
        'list-button': 'enterListView',
      },
    }
  }

  enterThumbnailView() {
    this.wrapper.classList.add('is-thumbnail')
    this.listButton.classList.remove('is-active')
    this.thumbnailButton.classList.add('is-active')
  }

  enterListView() {
    this.wrapper.classList.remove('is-thumbnail')
    this.thumbnailButton.classList.remove('is-active')
    this.listButton.classList.add('is-active')
  }
}
